import { render } from "./Volunteer.vue?vue&type=template&id=08cc8973&scoped=true"
import script from "./Volunteer.vue?vue&type=script&lang=js"
export * from "./Volunteer.vue?vue&type=script&lang=js"

import "./Volunteer.vue?vue&type=style&index=0&id=08cc8973&lang=scss&scoped=true"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08cc8973"]])

export default __exports__